<img [ngSrc]="linkToSvg$ | async" [width]="width" [height]="height" class="qr-code" alt="qrCode">